import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { FeatureSpecsEntities } from 'client/data/models/vehicle-v2';

import './color-list.scss';

function ColorListItem({ name, rgb }) {
  return (
    <li title={name} className="color-item" style={{ backgroundColor: `rgb(${rgb})` }}>
      <span className="visually-hidden">{name}</span>
    </li>
  );
}

ColorListItem.propTypes = {
  name: PropTypes.string.isRequired, // ex: "Cosmic Blue Metallic"
  rgb: PropTypes.string.isRequired, // ex: "70,69,107"
};

export function ColorList({ className, colors, keyPrefix }) {
  return (
    <ul className={classnames('color-list', className)}>
      {colors.map(({ name, rgb }, index) => {
        const key = `${keyPrefix}${rgb}-${index}`;
        return <ColorListItem key={key} {...{ name, rgb }} />;
      })}
    </ul>
  );
}

ColorList.propTypes = {
  colors: PropTypes.arrayOf(FeatureSpecsEntities.ColorEntity).isRequired,
  className: PropTypes.string,
  keyPrefix: PropTypes.string,
};

ColorList.defaultProps = {
  className: null,
  keyPrefix: '',
};
